import "../responsive/index.js";

window.Sparkle ??= {};
window.Sparkle.MobileCTA ??= {};

Sparkle.MobileCTA.Teasers = class Teasers {
  constructor(appendToSelector) {
    this.add = this.add.bind(this);
    this.addSpComponent = this.addSpComponent.bind(this);
    this.allowAdd = this.allowAdd.bind(this);
    this.handleMobileBreakpointEnter = this.handleMobileBreakpointEnter.bind(this);
    this.handleMobileBreakpointExit = this.handleMobileBreakpointExit.bind(this);
    this.hide = this.hide.bind(this);
    this.show = this.show.bind(this);
    this.el = jQuery(`<div class=${this.className}>`);
    if (this.testId) {
      this.el.attr("data-testid", this.testId);
    }
    jQuery(appendToSelector).append(this.el);
    this.el.hide();

    // BEHAVIOUR

    new Sparkle.Responsive.mediaCheck({
      media: "(max-width:" + Sparkle.Responsive.Entities.tablet + "px)",
      entry: this.handleMobileBreakpointEnter,
      exit: this.handleMobileBreakpointExit,
    });
  }

  // DSL

  add(title, ctaType, callback) {
    if (!this.allowAdd()) {
      return;
    }

    const classes = this.getKlasses(ctaType);

    const attributes = {
      role: "button",
      tabindex: "0",
      class: classes,
    };

    if (this.teaserTestId) {
      attributes["data-testid"] = this.teaserTestId;
    }

    const teaser = jQuery("<a>", attributes);

    teaser.on("click", callback);

    return this.el.append(teaser.append(jQuery("<h2>").append(title)));
  }

  addSpComponent(element) {
    if (!this.allowAdd()) {
      return;
    }

    element = jQuery(element);
    if (this.teaserTestId) {
      element.attr("data-testid", this.teaserTestId);
    }
    return this.el.append(element);
  }

  getKlasses(ctaType) {
    const classes = ["mobile-cta-teaser"];
    if (ctaType) {
      classes.push(`mobile-cta-teaser-${ctaType}`);
    }

    return classes.join(" ");
  }

  allowAdd() {
    const maxTeasers = 2;
    return this.el.children().length < maxTeasers;
  }

  // EVENT HANDLERS

  handleMobileBreakpointEnter(event) {
    return this.show();
  }

  handleMobileBreakpointExit(event) {
    return this.hide();
  }

  // HELPERS

  hide() {
    return this.el.css("display", "none");
  }

  show() {
    // Since these events are added before the element is attached to the DOM
    // jquery defaults the display to "block" on show()
    // Instead add/remove display none so we can retain the display set through the css.
    return this.el.css("display", "");
  }
};
